import React from 'react';
import PropTypes from 'prop-types';
import { Input as AntInput } from 'turing-uiux';
import './style.css';

const randomId = `turing-ui-input-${Math.floor(Math.random() * 10000)}`;

const Input = props => <AntInput id={randomId} {...props} />;

Input.defaultProps = {
  value: '',
  type: 'text',
  placeholder: '',
};

Input.propTypes = {
  placeholder: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
};

export default Input;
